import { createFileRoute } from '@tanstack/react-router'
import { DashboardPage } from '@/features/dashboard/dashboard-page'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/')({
  component: DashboardRoute,
})

function DashboardRoute() {
  const { workspaceSlug } = Route.useParams()

  return <DashboardPage workspaceSlug={workspaceSlug} />
}
